/**
 * Build FHIR AuditEvent search query from UI filters.
 * Calendar dates use YYYY-MM-DD as entered — no toISOString().slice(0, 10).
 */

export const AUDIT_EVENT_PAGE_SIZE = 50;

export type AuditEventActionFilter = '' | 'C' | 'R' | 'U' | 'D' | 'E';

export interface AuditEventSearchFilters {
  dateFrom: string;
  dateTo: string;
  action: AuditEventActionFilter;
  /** FHIR reference, e.g. Practitioner/uuid or Patient/uuid. */
  agent?: string;
  offset?: number;
  count?: number;
}

/** Query string so both date=ge… and date=le… can be sent. */
export function toAuditEventSearchQuery(filters: AuditEventSearchFilters): string {
  const parts: string[] = [
    '_sort=-date',
    `_count=${filters.count ?? AUDIT_EVENT_PAGE_SIZE}`,
    '_total=accurate',
  ];
  const offset = filters.offset ?? 0;
  if (offset > 0) {
    parts.push(`_offset=${offset}`);
  }
  if (filters.dateFrom) {
    parts.push(`date=ge${encodeURIComponent(filters.dateFrom)}`);
  }
  if (filters.dateTo) {
    parts.push(`date=le${encodeURIComponent(filters.dateTo)}`);
  }
  if (filters.action) {
    parts.push(`action=${encodeURIComponent(filters.action)}`);
  }
  if (filters.agent?.trim()) {
    parts.push(`agent=${encodeURIComponent(filters.agent.trim())}`);
  }
  return parts.join('&');
}
